// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1E5mS","box":"WorkspacesBox_box__Tfa6Z","node":"WorkspacesBox_node__1q9Vl"};